import React from 'react';
import ServiceLandingPage from './ServiceLandingPage';
import { pageMeta, faq, sections, steps } from '../content/executionContent';
import { executionSuccessStoryImages } from '../data/successStoriesImages';

const ExecutionLawyerPage = () => (
  <ServiceLandingPage
    {...pageMeta}
    faq={faq}
    sections={sections}
    steps={steps}
    showSuccessStories
    successStoryImages={executionSuccessStoryImages}
  />
);

export default ExecutionLawyerPage;
